'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.set.is-subset-of.v2');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.set.is-subset-of.v2.js
// module id = 1504
// module chunks = 0